import { useEffect, useState } from "react";
import useGeminiAi from "../../utils/custom-hooks/useGeminiAi";

const SearchComponent = () => {
    const [searchRequest, setsearchRequest] = useState(null);
    const [aiResponse, setAiResponse] = useState(null);

    let textValue = null;
    let imageValue = null;

    const getResponseFromGemini = async (prompt) => {
        const response = await useGeminiAi(prompt);

        if (response.responseReceived) {
            setAiResponse(response.responseData);
        } else {
            setAiResponse("something went wrong, try again later.");
        }
    };

    useEffect(() => {
        if (searchRequest) {
            getResponseFromGemini(searchRequest);
        }
    }, [searchRequest]);

    const geminiLayout = (
        <div className="search-container">
            <input
                type="text"
                className="gemini-search"
                placeholder="Ask anything to Google Gemini"
                onChange={(e) => {
                    textValue = e.target.value;
                }}
            />

            <div className="drag-file-area">
                <input
                    type="file"
                    className="gemini-image-upload"
                    onChange={(e) => {
                        imageValue = e.target.value;
                    }}
                />
            </div>

            <button
                className="gemini-search-btn"
                onClick={() => {
                    setsearchRequest({
                        text: textValue,
                        image: imageValue,
                    });
                }}>
                Search
            </button>

            {aiResponse && <div className="gemini-search-results">{aiResponse.replaceAll("**", "\n")}</div>}
        </div>
    );

    return geminiLayout;
};

export default SearchComponent;
